module.exports = __webpack_public_path__ + "img/export-white-icon.f2591b04.svg";